import * as THREE from "three";
import React, { useRef, useState } from "react";
import { useGLTF } from "@react-three/drei";
import { GLTF } from "three-stdlib";
import { useGameStore } from "../../stores/gameStore";
import { RapierRigidBody, RigidBody } from "@react-three/rapier";
import { useFrame } from "@react-three/fiber";

type GLTFResult = GLTF & {
  nodes: {
    Pouch: THREE.Mesh;
    Rope: THREE.Mesh;
  };
  materials: {
    Pouch: THREE.MeshStandardMaterial;
    Rope: THREE.MeshStandardMaterial;
  };
};

export const PouchStates = {
  PLACED: "PLACED",
  PICKED_UP: "PICKED_UP",
  REMOVED: "REMOVED",
};

export function Pouch(props: JSX.IntrinsicElements["group"]) {
  const { nodes, materials } = useGLTF("/models/assets/pouch.glb") as GLTFResult;
  const {
    pouchPosition,
    setPouchState,
    pouchValue,
    setPouchValue,
  } = useGameStore((state: any) => ({
    pouchPosition: state.pouchPosition,
    setPouchState: state.setPouchState,
    pouchValue: state.pouchValue,
    setPouchValue: state.setPouchValue,
  }));

  const { coins, setCoins } = useGameStore((state: any) => ({
    coins: state.coins,
    setCoins: state.setCoins,
  }));

  const pouchRef = useRef<RapierRigidBody>(null);
  const [curPouchPosition, setCurPouchPosition] = useState(new THREE.Vector3());

  useFrame((state) => {
    // Update the position of the pouch
    if (
      pouchPosition[0] !== curPouchPosition &&
      pouchPosition[0] &&
      pouchRef.current
    ) {
      pouchRef.current.setTranslation(
        new THREE.Vector3(
          pouchPosition[0].x,
          pouchPosition[0].y,
          pouchPosition[0].z
        ),
        true
      );
      setCurPouchPosition(pouchPosition[0]);
    }
  });
  
  const PickUp = () => {
    setCoins(coins + pouchValue);
    pouchPosition.splice(0, pouchPosition.length);
    setPouchValue(0);
    setPouchState(PouchStates.REMOVED);
  };

  return (
    <RigidBody
      name={"Pouch"}
      type={"kinematicPosition"}
      position={curPouchPosition}
      ref={pouchRef}
      onCollisionEnter={({ manifold, target, other }) => {
        if (other.rigidBodyObject!.name === "Sol") {
          setPouchState(PouchStates.PICKED_UP);
          PickUp();
        }
      }}
    >
      <group {...props} dispose={null}>
        <mesh
          name="Pouch"
          castShadow
          receiveShadow
          geometry={nodes.Pouch.geometry}
          material={materials.Pouch}
          scale={[0.191, 0.203, 0.191]}
          position={[0.3, -1, 0.3]}
        />
        <mesh
          name="Rope"
          castShadow
          receiveShadow
          geometry={nodes.Rope.geometry}
          material={materials.Rope}
          scale={[0.191, 0.203, 0.191]}
          position={[0.3, -1, 0.3]}
        />
      </group>
    </RigidBody>
  );
}

useGLTF.preload("/models/assets/pouch.glb");
